import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from 'src/app/shared/service/token.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-banner-type-list',
  templateUrl: './banner-type-list.component.html',
  styleUrls: ['./banner-type-list.component.scss']
})
export class BannerTypeListComponent implements OnInit {

  public menus = [];
  public selected = [];
  BannerTypeList;
  isLoading;
  isDeleting;
  DeletingItem;

  constructor(private router: Router, private http: HttpClient, private toastr: ToastrService, private modalService: NgbModal,private TokenService: TokenService) {
    const a = JSON.parse(this.TokenService.getUser().Authority);
    if (!a['BannerManagement']) {
      router.navigateByUrl('/');
    }
  }


  ngOnInit() {
    this.GetBannerTypeList();
  }

  GetBannerTypeList() {
    this.http.get<any>(environment.url + 'Banner/GetBannerTypes').subscribe(data => {
      this.BannerTypeList = data;
      this.isLoading = true;
    });
  }
  DeleteBannerType() {
    this.isDeleting = true;
    var body = { Ref: this.DeletingItem };
    this.http.post<any>(environment.url + 'Banner/RemoveBannerType', body).subscribe(data => {
      this.isDeleting = false;
      this.DeletingItem = "";
      this.GetBannerTypeList();
      if (!data.Error) {
        this.modalService.dismissAll();
        this.toastr.success("Banner Lokasyon Tipi Silindi", '', {
          timeOut: 3000,
        });
      }
      else {
        this.toastr.error("Banner Lokasyon Tipi Silinemedi", 'Hata !', {
          timeOut: 3000,
        });
      }
    });
  }
  gotoBannerTypeEdit(item: any) {
    const navigatioExtra: NavigationExtras = {
      queryParams: { id: item }
    }
    this.router.navigate(['/home/definitions/edit-banner-type'], navigatioExtra);
  }
  DeleteBannerTypeModal(file,ref) {
    this.DeletingItem = ref;
    this.modalService.open(file, { centered: true });
  }
  CloseDeleteModalClose(){
    this.modalService.dismissAll();
    this.DeletingItem = "";
  }
}
